import { Routes, Route, Navigate } from "react-router-dom";
import LoginComponent from "./pages/LoginComponent";
import SideBar from "./components/Sidebar";
import ViewSites from "./pages/Sites";
import Dashboard from "./pages/Dashboard";
import Statistics from "./pages/Statistics";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { NotificationProvider } from "./context/NotificationContext";
import HelpPage from "./pages/HelpPage";
import ReportPage from "./pages/ReportPage";
import Devices from "./pages/Devices";
import Receivers from "./pages/Receivers";
import AccountPage from "./pages/AccountPage";
import NotificationPage from "./pages/NotificationPage";
import SettingsPage from "./pages/SettingsPage";
import Groups from "./pages/Groups";
import AddSite from "./components/AddSite";
import AddGroup from "./components/AddGroup";
import AddDevice from "./components/AddDevice";
import AddReceiver from "./components/AddReceiver";
import UnauthorizedPage from "./components/UnauthorizedPage";
import LoadingScreen from "./components/LoadingScreen";
import EditSite from "./components/EditSite";
import EditGroup from "./components/EditGroup";
import EditDevice from "./components/EditDevice";
import AddWaterBalance from "./components/AddWaterBalance";
import EditWaterBalance from "./components/EditWaterBalance";
import WaterBalanceList from "./components/WaterBalanceList";
import HelpPage1 from "./pages/HelpPage1";
import FaqManagement from "./pages/FaqManagement";

const ProtectedRoute = ({ element, requireAdmin, allowSuperuser }) => {
  const { isAuthenticated, isAdmin, isSuperuser, loading } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <UnauthorizedPage redirectTo="/" />;
  }

  if (requireAdmin && !isAdmin) {
    return <UnauthorizedPage redirectTo="/dashboard" />;
  }

  if (allowSuperuser && !isAdmin && !isSuperuser) {
    return <UnauthorizedPage redirectTo="/dashboard" />;
  }

  return element;
};

function AppContent() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route path="/" element={<LoginComponent />} />
      <Route element={isAuthenticated ? <SideBar /> : <Navigate to="/" />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/sites" element={<ViewSites />} />
        <Route path="/dashboard/groups" element={<Groups />} />
        <Route path="/dashboard/devices" element={<Devices />} />
        <Route path="/dashboard/receivers" element={<Receivers />} />
        <Route path="/dashboard/statistics" element={<Statistics />} />
        <Route path="/dashboard/report" element={<ReportPage />} />
        <Route path="/dashboard/account" element={<AccountPage />} />
        <Route path="/dashboard/notification" element={<NotificationPage />} />
        <Route path="/dashboard/settings" element={<SettingsPage />} />
        <Route path="/dashboard/help" element={<HelpPage1 />} />

        {/* Create Paths */}
        <Route
          path="/sites/add"
          element={
            <ProtectedRoute element={<AddSite />} allowSuperuser={true} />
          }
        />
        <Route
          path="/groups/add"
          element={
            <ProtectedRoute element={<AddGroup />} requireAdmin={true} />
          }
        />
        <Route
          path="/devices/add"
          element={
            <ProtectedRoute element={<AddDevice />} requireAdmin={true} />
          }
        />
        <Route
          path="/receivers/add"
          element={
            <ProtectedRoute element={<AddReceiver />} requireAdmin={true} />
          }
        />

        {/* Update Paths */}
        <Route
          path="/sites/edit-site/:id"
          element={
            <ProtectedRoute element={<EditSite />} allowSuperuser={true} />
          }
        />
        <Route
          path="/groups/edit-group/:id"
          element={
            <ProtectedRoute element={<EditGroup />} requireAdmin={true} />
          }
        />
        <Route
          path="/devices/edit-device/:id"
          element={
            <ProtectedRoute element={<EditDevice />} requireAdmin={true} />
          }
        />

        <Route path="/water-balance/add" element={<AddWaterBalance />} />
        <Route path="/water-balance/edit/:id" element={<EditWaterBalance />} />
        <Route path="/water-balance/" element={<WaterBalanceList />} />
        {/* <Route path="/dashboard/help1" element={<HelpPage1 />} /> */}
        <Route path="/dashboard/faq" element={<FaqManagement />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <AppContent />
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
